export default __webpack_public_path__ + "static/media/pin.ff22a1b4.png";